import richTextEditorCentreAlignLink from "client/hooks/useRender/rteCentreAlignLink";
import richTextEditorStandaloneLink from "client/hooks/useRender/rteStandaloneLink";
import type { Options } from "markdown-it";
import { useCallback, useRef } from "react";

export interface Renderer {
  (src: string): string;
}

export const RENDERER_OPTIONS: Options = { html: true };

const useRender = () => {
  const rendererRef = useRef(globalThis.__renderer);
  rendererRef.current = globalThis.__renderer;

  const renderToStringRef = useRef(globalThis.__renderToString);
  renderToStringRef.current = globalThis.__renderToString;

  return useCallback((src?: string, background?: string) => {
    const render = rendererRef.current;
    const renderToString = renderToStringRef.current;

    if (!src || !render || !renderToString) return "";

    let returnedText = render(src);

    // RTE: Anchor
    returnedText = returnedText.replace(/<p><a id="(.*?)"><\/a><\/p>/g, (match: string) =>
      match.replace("<p>", "").replace("</p>", ""),
    );

    // RTE: Centre Align Link
    returnedText = returnedText.replace(/\[[^)]*\)/g, (match: string) => richTextEditorCentreAlignLink(match));

    // RTE: Standalone Link
    returnedText = returnedText.replace(/<p(>| class="(.*?)">)<a((?!<\/a> <a).)*<\/a><\/p>/g, (match: string) =>
      richTextEditorStandaloneLink(match, { background, renderToString }),
    );

    // RTE: Bug fix for when '&' is including in the Standalone Link
    returnedText = returnedText.replace(/&amp;amp;/g, "&amp;");

    // RTE: Open Link in New Tab
    returnedText = returnedText.replace(/href="(%5B|\\\[)NewTab(%5D|\\\])/g, `target="_blank" href="`);

    // remove single line paragraph <p> tags for hydration error
    returnedText = returnedText.replace(/^<p>(.+)<\/p>\n?$/, "$1");

    return returnedText;
  }, []);
};

export default useRender;
